import { c as _c } from "react/compiler-runtime";
import { Modal, PrimaryButton, SecondaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { InternalError } from '@systemeio/util';
import { ManageSubscriptionsInterface } from 'modules/profile/manage-subscriptions/types/manage-subscriptions-interface';
import React, { useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getCancelSubscriptionApiHandler } from '../utils/get-cancel-subscription-api-handler';
interface CancelSubscriptionModalProps {
  opened: boolean;
  onClose: () => void;
  subscription: ManageSubscriptionsInterface;
  onUnsubscribe: (subscriptionItemId: number) => Promise<void>;
}
function CancelSubscriptionModal(t0) {
  const $ = _c(47);
  const {
    opened,
    onClose,
    subscription,
    onUnsubscribe
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [error, setError] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== subscription.id || $[1] !== subscription.paymentProcessor || $[2] !== subscription.subscriptionItems[0].id) {
    t1 = getCancelSubscriptionApiHandler(subscription.paymentProcessor, subscription.id, subscription.subscriptionItems[0].id);
    $[0] = subscription.id;
    $[1] = subscription.paymentProcessor;
    $[2] = subscription.subscriptionItems[0].id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cancelSubscriptionApiHandler = t1;
  let t2;
  if ($[4] !== cancelSubscriptionApiHandler || $[5] !== onClose || $[6] !== onUnsubscribe || $[7] !== subscription.subscriptionItems[0].id || $[8] !== t) {
    t2 = async () => {
      ;
      try {
        setIsFetching(true);
        await cancelSubscriptionApiHandler();
        await onUnsubscribe(subscription.subscriptionItems[0].id);
        setIsFetching(false);
        onClose();
        toast.success(t("dashboard.subscriptions.unsubscribed"));
      } catch (t3) {
        const e = t3;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          if (e.errors.common) {
            setError(e.errors.common.join(""));
          }
        } else {
          if (e instanceof InternalError) {
            setError(t("core.error.internal_error_message"));
          } else {
            toast.error(t("global.error"));
          }
        }
      }
    };
    $[4] = cancelSubscriptionApiHandler;
    $[5] = onClose;
    $[6] = onUnsubscribe;
    $[7] = subscription.subscriptionItems[0].id;
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleConfirm = t2;
  let t3;
  if ($[10] !== t) {
    t3 = t("confirmation_modal.default_title");
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t) {
    t4 = t("dashboard.settings.manage_subscriptions.unsubscribe_confirmation");
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <div className="flex justify-center"><p>{t4}</p></div>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== onClose) {
    t6 = e_0 => {
      e_0.preventDefault();
      onClose();
    };
    $[16] = onClose;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t) {
    t7 = t("confirmation_modal.cancel");
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isFetching || $[21] !== t6 || $[22] !== t7) {
    t8 = <SecondaryButton width="large" onClick={t6} disabled={isFetching}>{t7}</SecondaryButton>;
    $[20] = isFetching;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== handleConfirm) {
    t9 = async e_1 => {
      e_1.preventDefault();
      await handleConfirm();
    };
    $[24] = handleConfirm;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t) {
    t10 = t("confirmation_modal.confirm");
    $[26] = t;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== isFetching || $[29] !== t10 || $[30] !== t9) {
    t11 = <PrimaryButton isFetching={isFetching} width="large" onClick={t9} type="submit">{t10}</PrimaryButton>;
    $[28] = isFetching;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t8) {
    t12 = <div className="flex justify-center gap-4">{t8}{t11}</div>;
    $[32] = t11;
    $[33] = t8;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== error) {
    t13 = <FieldErrorAndDescription error={error} errorClassName="text-center" />;
    $[35] = error;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t12 || $[38] !== t13 || $[39] !== t5) {
    t14 = <form className="flex flex-col gap-6 lg:gap-10">{t5}{t12}{t13}</form>;
    $[37] = t12;
    $[38] = t13;
    $[39] = t5;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== isFetching || $[42] !== onClose || $[43] !== opened || $[44] !== t14 || $[45] !== t3) {
    t15 = <><Modal opened={opened} onClose={onClose} title={t3} isFetching={isFetching}>{t14}</Modal></>;
    $[41] = isFetching;
    $[42] = onClose;
    $[43] = opened;
    $[44] = t14;
    $[45] = t3;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  return t15;
}
export default CancelSubscriptionModal;